(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/data/verbs', {
      templateUrl: 'modules/app/data/verbs/verbs.html',
      controller: 'DataVerbsCtrl',
      requiredPermissions: ['admin']
    });
  }]).controller('DataVerbsCtrl', ['$scope', function ($scope) {
    $scope.section = "verbs";
  }]);
})();
